import { Channels } from '@/core/constants/channelConstants';
import { Roles } from '@/core/constants/roleConstants';
import Policies from '@/core/policies';

export const navigationRoutes = [
  /*
   *** GENERAL
   */
  {
    label: 'Agenda',
    routeName: 'Schedule',
    matchRoutes: ['ScheduleCalendar', 'ScheduleMetrics'],
    roles: [
      Roles.SELLER,
      Roles.SUB_MANAGER,
      Roles.MANAGER,
      Roles.REGIONAL_MANAGER,
      Roles.SUB_DIRECTOR,
      Roles.DIRECTOR,
      Roles.EXPRESS_SALES,
      Roles.SUPER_USER,
      Roles.POST_SALE,
    ],
    channels: [
      Channels.WHOLESALER,
      Channels.RETAIL,
      Channels.EXPORT,
      Channels.INDUSTRIAL,
      Channels.MODERN,
      Channels.PROJECT,
      Channels.ECOMMERCE,
    ],
  },
  {
    label: 'Visor',
    routeName: 'Visor',
    roles: [Roles.PRESIDENCY],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },

  /*
   *** SELLER
   */
  {
    label: 'Resultados',
    routeName: 'SellerResults',
    roles: [Roles.SELLER],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Planeador',
    routeName: 'PlaneadorSeller',
    roles: [Roles.SELLER],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Renglonaje por Cliente',
    routeName: 'RenglonajeByCustomerSeller',
    roles: [Roles.SELLER],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Cartera',
    routeName: 'Briefcase',
    roles: [Roles.SELLER],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Solicitud de Alta Cliente',
    routeName: 'RequestsSeller',
    roles: [Roles.SELLER],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Vinculos',
    routeName: 'VinculosSeller',
    roles: [Roles.SELLER],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Panel IUSASOL',
    routeName: 'Panelsol',
    roles: [Roles.SELLER],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Órdenes de Compra',
    routeName: 'OCPendientes',
    roles: [Roles.SELLER],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Presupuesto',
    routeName: 'QuotationStatistics',
    roles: [Roles.SELLER],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Historial Backorder',
    routeName: 'backordersHistorySeller',
    roles: [Roles.SELLER],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Ingreso Semanal',
    routeName: 'WeeklyEarningsSeller',
    roles: [Roles.SELLER],
    channels: [Channels.WHOLESALER],
    hidden: () => !Policies.WeeklyEarningsPolicy.canView(),
  },

  /*
   *** MANAGER
   */
  {
    label: 'Diario',
    routeName: 'ManagerHome',
    roles: [Roles.MANAGER, Roles.SUB_MANAGER],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Planeador',
    routeName: 'PlaneadorManager',
    roles: [Roles.MANAGER, Roles.SUB_MANAGER],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },

  {
    label: 'Solicitud de Alta de Cliente',
    routeName: 'RequestManager',
    roles: [Roles.MANAGER, Roles.SUB_MANAGER],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Solicitudes Pagaré',
    routeName: 'PromissoryNotes',
    roles: [Roles.MANAGER, Roles.SUB_MANAGER],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Renglonaje',
    routeName: 'RenglonajeByFamilyManager',
    roles: [Roles.MANAGER, Roles.SUB_MANAGER],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Renglonaje por Cliente',
    routeName: 'RenglonajeByCustomerManager',
    roles: [Roles.MANAGER, Roles.SUB_MANAGER],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },

  {
    label: 'Vínculos',
    routeName: 'VinculosManager',
    roles: [Roles.MANAGER, Roles.SUB_MANAGER],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },

  {
    label: 'Gestor de Proyectos',
    routeName: 'ProjectManager',
    roles: [Roles.MANAGER, Roles.SUB_MANAGER],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Historial Backorder',
    routeName: 'backordersHistoryManager',
    roles: [Roles.MANAGER, Roles.SUB_MANAGER],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },

  /*
   *** REGIONAL MANAGER
   */
  {
    label: 'Renglonaje',
    routeName: 'RenglonajeByFamilyRegional',
    roles: [Roles.REGIONAL_MANAGER],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Solicitud de Alta de Cliente',
    routeName: 'RequestRegional',
    roles: [Roles.REGIONAL_MANAGER],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Estructura (Gte Regional)',
    routeName: 'StructureRegionalManager',
    roles: [Roles.REGIONAL_MANAGER],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Diario',
    routeName: 'DailyRegionalManager',
    roles: [Roles.REGIONAL_MANAGER],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Mostradores',
    routeName: 'GeneralGroupDataCountersRegional',
    roles: [Roles.REGIONAL_MANAGER],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Vínculos',
    routeName: 'VinculosRegional',
    roles: [Roles.REGIONAL_MANAGER],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Gestor de Proyectos',
    routeName: 'ProjectRegional',
    roles: [Roles.REGIONAL_MANAGER],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Historial Backorder',
    routeName: 'backordersHistoryRegional',
    roles: [Roles.REGIONAL_MANAGER],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Renglonaje por Cliente',
    routeName: 'RenglonajeByCustomerRegional',
    roles: [Roles.REGIONAL_MANAGER],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },

  /*
   *** DIRECTOR
   */
  {
    label: 'Renglonaje',
    routeName: 'RenglonajeByFamilyDirector',
    roles: [
      Roles.DIRECTOR,
      Roles.DIRECTOR_NON_COMMERCIAL,
      Roles.SUB_DIRECTOR,
      Roles.SUB_DIRECTOR_NON_COMMERCIAL_WHOLESALER,
      Roles.SUB_DIRECTOR_NON_COMMERCIAL_RETAIL,
      Roles.MARKETING,
      Roles.POST_SALE,
      Roles.SUPER_USER,
    ],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Estructura (Director)',
    routeName: 'StructureDirector',
    roles: [
      Roles.DIRECTOR,
      Roles.DIRECTOR_NON_COMMERCIAL,
      Roles.SUB_DIRECTOR,
      Roles.SUB_DIRECTOR_NON_COMMERCIAL_WHOLESALER,
      Roles.SUB_DIRECTOR_NON_COMMERCIAL_RETAIL,
      Roles.MARKETING,
      Roles.POST_SALE,
      Roles.SUPER_USER,
    ],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Diario',
    routeName: 'DailyDirector',
    roles: [
      Roles.DIRECTOR,
      Roles.DIRECTOR_NON_COMMERCIAL,
      Roles.MARKETING,
      Roles.POST_SALE,
      Roles.SUPER_USER,
    ],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Diario',
    routeName: 'DailySubDirector',
    roles: [
      Roles.SUB_DIRECTOR,
      Roles.SUB_DIRECTOR_NON_COMMERCIAL_WHOLESALER,
      Roles.SUB_DIRECTOR_NON_COMMERCIAL_RETAIL,
    ],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Mostradores',
    routeName: 'GeneralGroupDataCountersDirector',
    roles: [
      Roles.DIRECTOR,
      Roles.DIRECTOR_NON_COMMERCIAL,
      Roles.SUB_DIRECTOR,
      Roles.SUB_DIRECTOR_NON_COMMERCIAL_WHOLESALER,
      Roles.SUB_DIRECTOR_NON_COMMERCIAL_RETAIL,
      Roles.MARKETING,
      Roles.POST_SALE,
      Roles.SUPER_USER,
    ],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Vínculos',
    routeName: 'VinculosDirector',
    roles: [
      Roles.DIRECTOR,
      Roles.DIRECTOR_NON_COMMERCIAL,
      Roles.SUB_DIRECTOR,
      Roles.SUB_DIRECTOR_NON_COMMERCIAL_WHOLESALER,
      Roles.SUB_DIRECTOR_NON_COMMERCIAL_RETAIL,
      Roles.MARKETING,
      Roles.POST_SALE,
      Roles.SUPER_USER,
    ],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Gestor de Proyectos',
    routeName: 'ProjectDirector',
    roles: [
      Roles.DIRECTOR,
      Roles.DIRECTOR_NON_COMMERCIAL,
      Roles.SUB_DIRECTOR,
      Roles.SUB_DIRECTOR_NON_COMMERCIAL_WHOLESALER,
      Roles.SUB_DIRECTOR_NON_COMMERCIAL_RETAIL,
      Roles.MARKETING,
      Roles.POST_SALE,
      Roles.SUPER_USER,
    ],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Canales',
    routeName: 'DirectorChannelSelection',
    roles: [
      Roles.DIRECTOR,
      Roles.DIRECTOR_NON_COMMERCIAL,
      Roles.MARKETING,
      Roles.POST_SALE,
      Roles.SUPER_USER,
      Roles.PRESIDENCY,
    ],
    channels: [
      Channels.WHOLESALER,
      Channels.RETAIL,
      Channels.EXPORT,
      Channels.INDUSTRIAL,
      Channels.MODERN,
      Channels.PROJECT,
      Channels.ECOMMERCE,
    ],
  },

  /*
   *** ADMIN
   */
  {
    label: 'Administrador Promociones',
    routeName: 'AdminPromotions',
    roles: [Roles.ADMIN_PROMOTION],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Notificaciones',
    routeName: 'Notifications',
    roles: [Roles.ADMIN_NOTIFICATION],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },

  /*
   *** LOGISTICS
   */
  {
    label: 'Ciclo de Venta',
    routeName: 'logistics_reports',
    roles: [Roles.LOGISTICS],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },

  /*
   *** CREDIT
   */
  {
    label: 'Solicitud de Alta de Cliente',
    routeName: 'CreditIndex',
    roles: [Roles.CREDIT_COLLECTIONS, Roles.CREDIT_ASSISTANT],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Historial Altas',
    routeName: 'CreditHistory',
    roles: [Roles.CREDIT_COLLECTIONS, Roles.CREDIT_ASSISTANT],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Mis Descargas',
    routeName: 'DownloadJobs',
    roles: [Roles.CREDIT_COLLECTIONS, Roles.CREDIT_ASSISTANT],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Pagarés',
    routeName: 'PromissoryIndex',
    roles: [Roles.CREDIT_COLLECTIONS, Roles.CREDIT_ASSISTANT],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Pedidos Pen. por Autorizar',
    routeName: 'PendingAuthorization',
    roles: [Roles.CREDIT_COLLECTIONS],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Pedidos Rechazados',
    routeName: 'RejectedOrders',
    roles: [Roles.CREDIT_COLLECTIONS],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Anticipos',
    routeName: 'DirectorChannelSelection',
    roles: [Roles.CREDIT_COLLECTIONS],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },

  /*
   *** OTHER
   */
  {
    label: 'Historial Backorder',
    routeName: 'backordersHistory',
    roles: [Roles.EXPRESS_SALES],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
  {
    label: 'Canal Mostradores DT',
    routeName: 'ResultsExpressSales',
    roles: [
      Roles.CREDIT_COLLECTIONS,
      Roles.CREDIT_ASSISTANT,
      Roles.EXPRESS_SALES,
      Roles.BRIEFCASE,
    ],
    channels: [Channels.RETAIL, Channels.WHOLESALER],
  },
  {
    label: 'Canal Distribución PR',
    routeName: 'ResultsExpressSalesPR',
    roles: [
      Roles.CREDIT_COLLECTIONS,
      Roles.CREDIT_ASSISTANT,
      Roles.EXPRESS_SALES,
      Roles.BRIEFCASE,
    ],
    channels: [Channels.WHOLESALER, Channels.RETAIL],
  },
];

export const getUserRoutes = ({ role, channel, context = {} }) => {
  return navigationRoutes.filter((route) => {
    const matchRole = route.roles.includes(role);
    const matchChannel = route.channels.includes(channel);
    const isHidden = route.hidden?.(context) ?? false;

    return !isHidden && matchRole && matchChannel;
  });
};

export const findActiveRoute = (routes, currentRouteName) => {
  return routes.find((route) =>
    route.matchRoutes
      ? route.matchRoutes.includes(currentRouteName)
      : route.routeName === currentRouteName
  );
};
